import Input from '@active/react-ui/Input';
import XRegExp from 'xregexp';

let NAME_REGEXP;
try {
  NAME_REGEXP = XRegExp("(?:^[\\p{L}\\p{Thai}](?!.*([ '-]).*\\1)[\\p{L}\\p{Thai} '-]{0,125}[\\p{L}\\p{Thai}]$)|^[\\p{L}\\p{Thai}]$", 'u');
} catch (e) {
  // For IE
  NAME_REGEXP = XRegExp("(?:^[\\p{L}\\p{Thai}](?!.*([ '-]).*\\1)[\\p{L}\\p{Thai} '-]{0,125}[\\p{L}\\p{Thai}]$)|^[\\p{L}\\p{Thai}]$");
}

export const validateName = (value) => { return NAME_REGEXP.test(value); };

const nameValidatorBuilder = (value) => {
  if (value && !validateName(value)) {
    return 'checkout.lib.components.error.validate.personName';
  }
  return '';
};

export default {
  field: [{
    name: 'firstName',
    label: 'checkout.lib.components.common.contact.field.firstName',
    component: Input,
    required: true,
    maxLength: 255,
    validate: nameValidatorBuilder,
    autoComplete: 'given-name',
  },
  {
    name: 'lastName',
    label: 'checkout.lib.components.common.contact.field.lastName',
    component: Input,
    required: true,
    maxLength: 255,
    validate: nameValidatorBuilder,
    autoComplete: 'family-name',
  }],
};
